<p *ngIf="style !== 'underline'" [ngClass]="classes" [innerHTML]="text" [ngStyle]="this.mobileSize !== 0 ? {'font-size' : rem(this.mobileSize)} : {'font-size' : ''}"></p>
<u *ngIf="style === 'underline'">
  <p [ngClass]="classes" [innerHTML]="text" [ngStyle]="this.mobileSize !== 0 ? {'font-size' : rem(this.mobileSize)} : {'font-size' : ''}"></p>
</u>
